import { motion } from 'framer-motion';
import V4_1 from '../../assets/images/home/vector4/vector4-1.svg';
import V4_2 from '../../assets/images/home/vector4/vector4-2.svg';
import V4_3 from '../../assets/images/home/vector4/vector4-3.svg';
import V4_4 from '../../assets/images/home/vector4/vector4-4.svg';
import V4_5 from '../../assets/images/home/vector4/vector4-5.svg';
import V4_6 from '../../assets/images/home/vector4/vector4-6.svg';

const Vector4 = () => {
  return (
    <motion.div className="vector" id="vector4"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true, amount: 0.1 }}
    >
      <img src={V4_1} alt="Décoration à gauche" />
      <img src={V4_2} alt="Décoration à gauche" />
      <img src={V4_3} alt="Décoration à gauche" />
      <img src={V4_4} alt="Décoration à gauche" />
      <img src={V4_5} alt="Décoration à gauche" />
      <img src={V4_6} alt="Décoration à gauche" />
    </motion.div>
  );
};

export default Vector4;